import { Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from "@material-ui/core/Button"
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import lodashGet from 'lodash.get'

const useStyles = makeStyles((theme) => ({
    cell: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    container: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0.5),
    },
    errorBorder: {
        borderColor: theme.palette.error.main,
    },
    errorText: {
        color: theme.palette.error.dark,
    },
    saveButton: {
        margin: "1rem",
        height: "2rem"
    }
}))

const UserTokenRow = ({ name, description, feat, updateUserTokenlength, errorMsg }) => {
    const classes = useStyles()
    const [userTokenError, setUserTokenErrorr] = useState();
    const [userTokenLength, setUserTokenLength] = useState("");
    const [userTokenLengthUpdated, setuserTokenLengthUpdated] = useState(false);

    useEffect(() => {
        setUserTokenLength(lodashGet(feat, 'configuration.userTokenLength', ''))
        setUserTokenErrorr(errorMsg)
    }, [feat, errorMsg])

    const onChangeUserTokenLength = async (event) => {
        const newValue = event.target.value;

        setUserTokenLength(newValue)

        if (newValue === "" || newValue < 7 || newValue > 20) {
            setUserTokenErrorr('Minimum is 7 and maximun is 20')
            return
        } else {
            setUserTokenErrorr("")
        }
        setuserTokenLengthUpdated(true)
    }

    return (
        <Paper {...getContainerProps(errorMsg)}>
            <Grid container>
                <Grid className={classes.cell} item xs={3}>
                    <Typography variant="body1">{name}</Typography>
                </Grid>
                <Grid className={classes.cell} item xs={6}>
                    <Typography variant="body1">{description}</Typography>
                </Grid>
                <Grid className={classes.cell} item xs={3}>
                    <input
                        type="number"
                        placeholder="userToken length"
                        disabled={!lodashGet(feat, 'enabled', true)}
                        value={userTokenLength}
                        onChange={onChangeUserTokenLength}
                        />
                    <Button
                        className={classes.saveButton}
                        color="primary"
                        variant="contained"
                        onClick={() => updateUserTokenlength(userTokenLength)}
                        disabled={!userTokenLengthUpdated}
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
            {userTokenError ? (
                <Grid item xs={12}>
                    <Typography variant="body1" align="center" className={classes.errorText}>
                        {userTokenError}
                    </Typography>
                </Grid>
            ) : (
                <></>
            )}
        </Paper>
    )
}

const getContainerProps = (errorMsg) => {
    const classes = useStyles()

    return {
        className: classes.container + (errorMsg ? ' ' + classes.errorBorder : ''),
        variant: errorMsg ? 'outlined' : undefined,
        elevation: 0,
    }
}

export default UserTokenRow
